import { sparkEnd, sparkPath } from "./scale";

/**
 * A sparkline: one 2px line, left to right, with an end dot ringed in the
 * surface colour. A trend beside a number, never the only place the number
 * is (`aria-hidden`).
 */
export function Sparkline({
	values,
	color = "var(--color-board)",
	className = "h-[1.25rem] w-[4.5rem]",
}: {
	values: readonly number[];
	color?: string;
	className?: string;
}) {
	const W = 72;
	const H = 20;
	const d = sparkPath(values, W, H, 3);
	const end = sparkEnd(values, W, H, 3);
	if (!d) return <span aria-hidden="true" className={`inline-block ${className}`} />;
	return (
		<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true" className={`inline-block overflow-visible ${className}`}>
			<path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
			{end && <circle cx={end.x} cy={end.y} r="2.5" fill={color} stroke="var(--color-sheet)" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />}
		</svg>
	);
}
